define('BluePoint.ValidateRegistration.ValidateRegistration'
,   [
		'BluePoint.ValidateRegistration.ValidateRegistration.View'
	]
,   function (
		ValidateRegistrationView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{			
			var LoginRegisterPage = container.getComponent('LoginRegisterPage');
			var MyAccountMenu = container.getComponent('MyAccountMenu');
			var environment = container.getComponent("Environment");
			var isactive = environment.getConfig('validateregistration.isactive');

			if (isactive && LoginRegisterPage) {
				return new ValidateRegistrationView ({
					LoginRegisterPage: LoginRegisterPage,
					environment: environment
				});
			}

			if (isactive && MyAccountMenu) {
				return new ValidateRegistrationView ({
					MyAccountMenu: MyAccountMenu,
					environment: environment
				});
			}
		}
	};
});
